import React from 'react';
import SwitchChannelButton from 'components/organisms/entity/edit/SwitchChannelButton';
import PropTypes from 'prop-types';
import ProtectedComponent from 'hoc/ProtectedComponent';

const SwitchChannelToggleContainer = ({ switchWorkOrderPlatforms, fieldKey, platforms }) => (
    <div>
        {
            platforms.map((platform) => {
                const requiresCapability = !!platform.capability;
                const ProtectedPlatformButton = ProtectedComponent({
                    requiredCapabilities: [platform.capability],
                    alwaysRender: !requiresCapability
                })(() =>
                    <SwitchChannelButton
                        switchWorkOrderPlatforms={switchWorkOrderPlatforms}
                        fieldKey={fieldKey}
                        platform={platform}
                    />
                );

                return <ProtectedPlatformButton key={platform.value}/>;
            })
        }
    </div>
);

SwitchChannelToggleContainer.propTypes = {
    fieldKey: PropTypes.string,
    switchWorkOrderPlatforms: PropTypes.func,
    platforms: PropTypes.array
};

export default SwitchChannelToggleContainer;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/SwitchChannelToggleContainer.js